"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
const utils_1 = require("./utils");
const DateOverviewSelector = ({ selectorAnimationDirection, value, selectedValueIndex, device, page, onSelect, }) => {
    const selectedValue = selectedValueIndex === undefined ? value : value[selectedValueIndex];
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            top: 56,
            left: 0,
            zIndex: 3,
            width: device === 'Mobile' ? '100%' : 384,
            height: device === 'Mobile' ? '100%' : 378,
            background: index_1.white,
            animation: `${page === 'dateOverview' && selectorAnimationDirection} 150ms ease-in-out`,
        } },
        React.createElement("div", { style: {
                padding: device !== 'Mobile' ? '0 16px' : '0 24px',
            } },
            React.createElement("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => onSelect('selectDatePicker') },
                React.createElement(index_1.Text, { text: utils_1.getDisplayDate(selectedValue), size: device === 'Mobile' ? 'large' : 'medium' }),
                React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver })),
            React.createElement("div", { style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    borderBottom: `1px solid ${index_1.titanium}`,
                }, onClick: () => onSelect('selectTimePicker') },
                React.createElement(index_1.Text, { text: utils_1.getDisplayTime(selectedValue), size: device === 'Mobile' ? 'large' : 'medium' }),
                React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver })))));
};
exports.default = DateOverviewSelector;
